import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import MuiDialog from "../../shared/mui-dialog/mui-dialog";
import { useNavigate } from "react-router-dom";
import UserAPIKey from "../../components/user-api-key/user-api-key";
import { addNewApiKey, deleteAPIKey, getAllKeys } from "../../services/user-api-key-service";
import AddNewUserAPIKeyPopup from "../../components/user-api-key/add-user-api-key-popup";
import UserAPIKeyHistory from "../../components/user-api-key/user-api-key-history";

export class APIkeyState {
    keyList = [];
    apiKeyListHeader = [
        { headerTitle: "Key Name" },
        { headerTitle: "Key" },
        { headerTitle: "Created Date" },
        { headerTitle: " " },
    ];
    isShowPopUp = false;
    errorMessage = null;
    isShowAddNewPopUp = false;
    enchorEl = null;
    selectedMenuIndex = null;
    isMenuOpen = false;
    keyUId = "";
    generatedApiKey = null;
    isReadOny = false;
    apiKeyListHistoryHeader = [
        { headerTitle: "Http Method" },
        { headerTitle: "Base Url" },
        { headerTitle: "Path" },
        { headerTitle: "Body" },
    ];
    isShowKeyHistoryPopUp = false;
    keyHistoryList = [];
}

export class FormDataState {
    name = "";
}

const UserAPIkeyController = (props) => {
    const [state, setState] = useState(new APIkeyState());
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [formData, setFormData] = useState(new FormDataState());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(async () => {
        await getAllApiKeys();
    }, [])

    useEffect(() => {
        checkIfSaveDisabled();
    });


    const getAllApiKeys = async () => {
        try {
            const response = await getAllKeys();
            if (response?.hasError) {
                toast.error(response?.errorMessage);
            }
            else {
                setState((prevState) => { return { ...prevState, keyList: response?.data} });
            }
        } catch (error) {

        }
    }

    const saveNewAPIKeyHandler = async () => {
        setIsLoading(true);
        let userModel = { ...FormDataState };
        userModel.name = formData.name;
        try {
            const response = await addNewApiKey(userModel);
            if (response?.hasError) {
                toast.error(response?.errorMessage);
            }
            else if (response?.data) {
                await getAllApiKeys();

                setState((prevState) => { return { ...prevState, generatedApiKey: response?.data?.hashKey, isReadOny: true} });
                setIsLoading(false);
                // setFormData(new FormDataState());
                // handleCloseAddNewDialog();
            }
        } catch (error) {
            toast.error(error);
        }
    };

    const openMenuOption = (event, isOpen, index) => {

        resetErrorMessages();
        if (event)
            event.stopPropagation();

        setState((prevState) => {
            return {
                ...prevState, isMenuOpen: isOpen,
                enchorEl: event.target,
                selectedMenuIndex: index
            }
        });
    }

    const closeMenuOption = (event) => {

        resetErrorMessages();
        if (event)
            event.stopPropagation();

        setState((prevState) => {
            return {
                ...prevState, isMenuOpen: false,
                enchorEl: null,
                selectedMenuIndex: null
            }
        });
    }

    const handleInputChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    }

    const checkIfSaveDisabled = () => {
        const isNameEmpty = !formData?.name?.trim();

        const isDisabled = isNameEmpty

        setSaveDisabled(isDisabled);
    };


    const handleDeletePopUpState = () => {
        setState((prevState) => {
            return {
                ...prevState, isShowPopUp: false,
            }
        });
    }

    const resetErrorMessages = () => {
        if (state.errorMessage)
            setState((prevState) => { return { ...prevState, errorMessage: null, } });
    }

    const closeDeleteDialog = () => {
        resetErrorMessages();
        setState((prevState) => {
            return {
                ...prevState, isShowPopUp: false
            }
        });
    }

    const onShowAddNewPopUp = () => {
        resetErrorMessages();
        setFormData(new FormDataState());
        setState((prevState) => {
            return {
                ...prevState, isShowAddNewPopUp: true
            }
        });
    }

    const handleCloseAddNewDialog = () => {
        resetErrorMessages();
        setFormData(new FormDataState());
        setState((prevState) => {
            return {
                ...prevState, isShowAddNewPopUp: false
                , isReadOny: false
                , generatedApiKey: null
            }
        });
    }

    const onKeyDelete = async (event, data) => {
        resetErrorMessages();
        if (event)
            event?.stopPropagation();
        closeMenuOption();

        if (data) {
            setState((prevState) => {
                return {
                    ...prevState, isShowPopUp: true,
                    keyUId: data?.uId
                }
            });
        }

        if (state?.isShowPopUp) {
            handleDeletePopUpState();
            const response = await deleteAPIKey(state?.keyUId);
            if (!response?.hasError) {
                let keyLists = state?.keyList;
                keyLists.splice(keyLists.findIndex(a => a?.uId === state?.keyUId), 1);

                setState((prevState) => {
                    return {
                        ...prevState, keyList: keyLists,
                    }
                });
                toast.success("API Key deleted successfully.");
            }
            else {
                setState((prevState) => { return { ...prevState, errorMessage: response?.errorMessage, } });
                toast.error(response?.errorMessage);
            }
        }
    }

    const handleCopyKey = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("API key copied successfully.");
    };

    const onShowKeyHistoryPopUp = (event, data) => {
        resetErrorMessages();
        if (event)
            event?.stopPropagation();
        closeMenuOption();

        setState((prevState) => {
            return {
                ...prevState, isShowKeyHistoryPopUp: true, keyHistoryList: data?.apiKeyLoginHistories
            }
        });
    }

    const handleCloseKeyHistoryDialog = () => {
        setState((prevState) => {
            return {
                ...prevState, isShowKeyHistoryPopUp: false, keyHistoryList: []
            }
        });
    }

    return (
        <>
            <MuiDialog
                isShowPopUp={state?.isShowPopUp}
                secondaryButtonAction={closeDeleteDialog}
                primaryButtonAction={onKeyDelete}
                closeDialog={closeDeleteDialog}
                secondaryButtonTitle="No"
                primaryButtonTitle="Yes"
                titleDescription="Are you sure you want to delete this API key?"
            />
            <UserAPIKey
                state={state}
                setState={setState}
                onShowAddNewPopUp={onShowAddNewPopUp}
                closeMenuOption={closeMenuOption}
                openMenuOption={openMenuOption}
                onKeyDelete={onKeyDelete}
                handleCopyKey={handleCopyKey}
                onShowKeyHistoryPopUp={onShowKeyHistoryPopUp}
            />
            <AddNewUserAPIKeyPopup
                open={state?.isShowAddNewPopUp}
                handleCloseDialog={handleCloseAddNewDialog}
                handleInputChange={handleInputChange}
                saveDisabled={saveDisabled}
                formData={formData}
                saveNewAPIKeyHandler={saveNewAPIKeyHandler}
                handleCopyKey={handleCopyKey}
                generatedKey={state?.generatedApiKey}
                readonly={state?.isReadOny}
                isLoading={isLoading}
            />
            <UserAPIKeyHistory
                keyHistoryList={state?.keyHistoryList}
                apiKeyListHistoryHeader={state?.apiKeyListHistoryHeader}
                open={state?.isShowKeyHistoryPopUp}
                handleCloseDialog={handleCloseKeyHistoryDialog}
            />
        </>
    )
}
export default UserAPIkeyController;